class CardBuy {
  constructor() {
    this._cartQueue = Promise.resolve()
    this._selectPending = null
    this.init()
  }

  init() {
    document.querySelectorAll('.buy-qty:not([data-listener="true"])').forEach((button) => {
      this.initCardBuy(button)
    })

    document.querySelectorAll('.option-values:not([data-listener="true"])').forEach((block) => {
      this.initOptionsBlock(block)
    })
  }

  initCardBuy(button) {
    // Add listener to all none listening attributes
    button.setAttribute('data-listener', 'true')

    // Add click event listener
    button.addEventListener('click', () => {
      const container = button.closest('add-to-cart')
      const input = container.querySelector('.buy-qty__input')

      if (button.classList.contains('buy-qty__overlay')) {
        // If the button has the class 'buy-qty__overlay', expand the add to cart element
        container.classList.add('expand', 'trash')
        container.querySelector('.buy-qty__input').value = 1

        this.addToCart(container, 1, 'overlay')
      }

      if (button.classList.contains('buy-qty__plus')) {
        // visible qty can rise each click (optional)
        input.value = (Number(input.value) || 0) + 1
        const hasMoreThanOne = input.value > 1
        container.classList.toggle('minus', hasMoreThanOne)
        container.classList.toggle('trash', !hasMoreThanOne)

        // current click count
        container._burstCount = (container._burstCount || 0) + 1

        // reset timer
        clearTimeout(container._burstTimer)
        container._burstTimer = setTimeout(() => {
          this.addToCart(container, container._burstCount, 'add-burst')

          // reset for the next burst
          container._burstCount = 0
        }, 500)
      }

      if (button.classList.contains('buy-qty__minus')) {
        // decrease visible qty
        let current = Number(input.value) || 0
        current = Math.max(0, current - 1) // don't go below 0
        input.value = current

        // toggle minus/trash classes
        const hasMoreThanOne = current > 1
        container.classList.toggle('minus', hasMoreThanOne)
        container.classList.toggle('trash', !hasMoreThanOne)

        const hasMoreThanZero = current > 0
        container.classList.toggle('expand', hasMoreThanZero)

        // update cart immediately with the new total
        clearTimeout(container._minusTimer)
        container._minusTimer = setTimeout(() => {
          this.updateCart(container, current, 'minus-update')
        }, 300) // small debounce to avoid spamming if held down
      }
    })
  }

  async addToCart(addtocart, qty) {
    this._cartQueue = this._cartQueue.then(async () => {
      try {
        const formData = {
          items: [{ id: addtocart.dataset.id, quantity: qty }],
        }

        const cartAdd = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        })

        await cartAdd.json()

        this.updateOptionCartQty(
          addtocart.dataset.id,
          Number(addtocart.querySelector('.buy-qty__input').value),
        )
      } catch (err) {
        console.error('addToCart error:', err)
      }
    })
  }

  async updateCart(addtocart, qty) {
    this._cartQueue = this._cartQueue.then(async () => {
      try {
        const variantId = Number(addtocart.dataset.id)

        const cart = await fetch('/cart.js').then((r) => r.json())
        const matches = cart.items.filter((item) => item.variant_id === variantId)

        if (!matches.length) {
          addtocart.classList.remove('expand')
          addtocart.querySelector('.buy-qty__input').value = 0
          this.updateOptionCartQty(variantId, 0)
          return
        }

        const updates = {}
        updates[matches[0].key] = qty
        for (let i = 1; i < matches.length; i++) {
          updates[matches[i].key] = 0
        }

        const cartUpdate = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })

        const cartResponse = await cartUpdate.json()

        if (!cartResponse?.items[0]?.quantity > 0) {
          addtocart.classList.remove('expand')
          addtocart.querySelector('.buy-qty__input').value = 0
        }

        this.updateOptionCartQty(variantId, qty)
      } catch (err) {
        console.error('updateCart error:', err)
      }
    })
  }

  updateOptionCartQty(variantId, qty) {
    const option = document.querySelector(`.option-value[data-variant-id="${variantId}"]`)
    if (option) {
      option.dataset.cartQty = qty
    }
  }

  initOptionsBlock(element) {
    element.setAttribute('data-listener', 'true')
    element.addEventListener('click', (event) => {
      if (event.target.classList.contains('option-value')) {
        cancelAnimationFrame(this._selectPending)
        const target = event.target
        this._selectPending = requestAnimationFrame(() => {
          this.selectOption(target, element)
        })
      }
    })
  }

  selectOption(optionElement, block) {
    try {
      const optionValues = optionElement.closest('.option-values')
      const optionBlock = optionValues ? optionValues.closest('.options-block') : null
      if (!optionBlock) return

      const selected = optionValues.querySelector('.option-value.selected')
      if (selected) {
        selected.classList.remove('selected')
      }
      optionElement.classList.add('selected')

      const variantId = optionElement.dataset.variantId
      const cartQty = Number(optionElement.dataset.cartQty) || 0
      const inventory = Number(optionElement.dataset.inventory) || 0
      const buyGroup = optionBlock.parentNode.querySelector('add-to-cart')
      if (!buyGroup) return

      // Update variant ID
      buyGroup.dataset.id = variantId

      // Update input
      const input = buyGroup.querySelector('.buy-qty__input')
      if (!input) return
      input.dataset.id = variantId
      input.value = cartQty
      input.max = inventory

      // Reset classes
      buyGroup.classList.remove('expand', 'minus', 'trash', 'has-stock', 'sold-out')

      // Add sold-out class if no inventory
      if (inventory < 1) {
        buyGroup.classList.add('sold-out')
      } else if (cartQty > 0) {
        buyGroup.classList.add('expand', 'has-stock')
        buyGroup.classList.add(cartQty > 1 ? 'minus' : 'trash')
      }

      // Update price
      const priceBlock = optionBlock.parentNode.querySelector('.price-block')
      if (priceBlock) {
        const currentPrice = priceBlock.querySelector('.price-block__current')
        const comparePrice = priceBlock.querySelector('.price-block__compare')

        if (currentPrice) {
          currentPrice.textContent = optionElement.dataset.price
        }

        if (
          optionElement.dataset.comparePrice &&
          optionElement.dataset.comparePrice !== optionElement.dataset.price
        ) {
          if (!comparePrice) {
            const newCompare = document.createElement('span')
            newCompare.className = 'price-block__compare'
            priceBlock.appendChild(newCompare)
          }
          const cp = priceBlock.querySelector('.price-block__compare')
          if (cp) cp.textContent = optionElement.dataset.comparePrice
          if (currentPrice) currentPrice.classList.add('sale')
        } else {
          if (comparePrice) comparePrice.remove()
          if (currentPrice) currentPrice.classList.remove('sale')
        }
      }

      // Update main image
      const groupBlock = optionBlock.closest('.group-block__image')
      const mainImage = groupBlock ? groupBlock.querySelector('img') : null

      if (mainImage && optionElement.dataset.image) {
        mainImage.src = optionElement.dataset.image
      }
    } catch (err) {
      console.error('selectOption error:', err)
    }
  }
}

export default CardBuy
